/**
 * DomColor(<ffp-generate.Color>, { attribute: 'fill' })
 * Returns an object which can be spread inside a jsx svg element, which allows
 * consistent use of attribute to handle SVG cmyk colorSpace through this app
 */

const EXPORT_PREFIX = 'data-exported-'
const ATTRIBUTES = ['fill', 'stroke']

export default (color, { attribute = 'fill' } = {}) => {
  if (!ATTRIBUTES.includes(attribute)) {
    throw new Error(`Expect 'attribute' to be one of [${ATTRIBUTES.join(',')}], got ${attribute}`)
  }

  return {
    [attribute]: color['css-cmyk-proof'],
    [EXPORT_PREFIX + attribute]: `device-cmyk(${color.cmyk})`
  }
}

// Apply all possible temporary attributes created by the above function
export const resolveCustomAttributes = svg => {
  for (const attribute of ATTRIBUTES) {
    const elements = svg.querySelectorAll(`[${EXPORT_PREFIX + attribute}]`)
    for (const element of elements) {
      const value = element.getAttribute(EXPORT_PREFIX + attribute)
      if (value) element.setAttribute(attribute, value)
    }
  }
}

export const resolveNamedValues = svg => {
  const colors = {
    white: 'device-cmyk(0, 0, 0, 0)',
    black: 'device-cmyk(0, 0, 0, 1)'
  }

  for (const name in colors) {
    for (const attr of ATTRIBUTES) {
      const elements = svg.querySelectorAll(`[${attr}=${name}]`)
      for (const element of elements) {
        element.setAttribute(attr, colors[name])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/dom-cmyk-color.js